module.exports = __webpack_public_path__ + "static/media/class_job_038.3f5cd7f2.svg";